const Parse = require('parse');
const SERVER_URL = 'https://funsizeapps.b4a.app/';
const APP_ID = 'rHwkgreMFdjMqUGu9EoemDE4YMomVNLQwIX9Czr9';
const JAVASCRIPT_KEY = 'xdllsMsa2dAhWFuovVzyJTj7OIZmzLMeo5vsEFYv';
Parse.initialize(APP_ID, JAVASCRIPT_KEY);
Parse.serverURL = SERVER_URL;

var funsizer, currentDataSource, currentDataEdit, btnNewS, attributes, cats, sets, spotModal, btnSave, btnCancel, adminTable, btnDel, delModal, testModal;
var isEditing = false;
const defaultImages = [
    new URL("../images/default/F.png", import.meta.url),
    new URL("../images/default/H.png", import.meta.url),
    new URL("../images/default/C.png", import.meta.url),
    new URL("../images/default/FH.png", import.meta.url),
    new URL("../images/default/CF.png", import.meta.url),
    new URL("../images/default/CH.png", import.meta.url),
    new URL("../images/default/CFH.png", import.meta.url)
];

window.addEventListener('load', () => {
    setUIState(false);
    btnNewS = document.getElementById('btn_new_spot');
    btnNewS.addEventListener('click', newSpot);
    spotModal = document.getElementById('modal_spot');
    btnCancel = document.getElementById('btn_cancel');
    btnSave = document.getElementById('btn_save');
    adminTable = document.getElementById('admin-table');
    btnCancel.onclick = cancelSpot;
    btnSave.onclick = saveSpot;
    document.getElementById('input_file').addEventListener('change', (e) => {
        document.getElementById('spot-image').src = URL.createObjectURL(e.target.files[0]);
    });
    delModal = document.getElementById('modal_delete');
    btnDel = document.getElementById('btn_delete');
    btnDel.addEventListener('click', () => {
        delModal.classList.remove('hidden');
    });
    document.getElementById('btn_nm').addEventListener('click', () => {
        delModal.classList.add('hidden');
    });
    document.getElementById('btn_delete_confirm').addEventListener('click', () => {
        setUIState(false);
        currentDataEdit.destroy().then((r) => {
            currentDataSource = currentDataSource.filter(p => p.id != currentDataEdit.id);
            currentDataEdit = null;
            setUIState(true);
            resetSpotUI();
            renderSpots();
            delModal.classList.add('hidden');
            cancelSpot();
        }, (error) => {
            setUIState(true);
            alert('Failed deleting object: ' + error);
            delModal.classList.add('hidden');
        });
    });
    testModal = document.getElementById('testModal');
    document.getElementById('spot_preview').addEventListener('click', () => {
        togglePreview();
    });
    document.getElementById('btn_tryAgain').addEventListener('click', () => {
        togglePreview();
    });
    initFunsizer();
});

const initFunsizer = () => {
    funsizer = Parse.User.current();
    if (funsizer) {
        setUIState(true);
        getAttributes().then(() => {
            getSpots().then(() => {
                renderSpots();
            }).catch(function (e) {
                handleParseError('Error when fetching Spots', e);
            });
        }).catch(function (e) {
            handleParseError('Error when fetching Attributes', e);
        });
    } else {
        window.location = `${window.location.origin}/${(window.location.pathname.includes("staging") ? "staging/" : "")}login.html?redirect=${window.location.pathname}`;
    }
}

const setUIState = (enabled) => {
    if (enabled) {
        gsap.to(document.getElementsByClassName('loader-container')[0], { opacity: 0, duration: 0.25 });
        document.body.style.pointerEvents = 'true';
    }
    else {
        gsap.to(document.getElementsByClassName('loader-container')[0], { opacity: 1, duration: 0.25 });
        gsap.to(document.getElementsByClassName('loader')[0], { scale: 0.5, duration: 1, ease: "bounce.out", repeat: -1, yoyo: true });
        document.body.style.pointerEvents = 'false';
    }
}

const togglePreview = () => {
    if (testModal.classList.contains('hidden')) {
        testModal.classList.remove('hidden');
        gsap.fromTo(testModal, { x: window.innerWidth }, { x: 0, duration: 0.5, ease: "expo.out(1, 0.5)" });
        document.getElementById('winner_name').innerHTML = document.getElementById('name').value;
        const item = document.getElementById('winner_img');
        item.src = document.getElementById('spot-image').src;

        document.querySelector('.quote-wrapper').classList.remove('hidden');
        document.getElementById('winner_quote').innerHTML = document.getElementById('quote').value.length > 0 ? `"${document.getElementById('quote').value.replace(new RegExp('"', 'g'), '')}"` : '';
        document.getElementById('winner_quotee').innerHTML = document.getElementById('quotee').value;

        document.getElementById('winner_address').innerHTML = document.getElementById('address').value;
        document.getElementById('winner_address').href = document.getElementById('map-link').value;
        const menu = document.getElementById('winner_menu');
        menu.classList.remove('hidden');
        menu.innerHTML = document.getElementById('website').value.replace('https://www.', '').replace('.com/', '.com');
    }
    else {
        testModal.classList.add('hidden');
    }
}

const updateDefaultImage = () => {
    if (currentDataEdit && currentDataEdit.get('Image')) { return; }
    const fInput = document.getElementById('input_file');
    if (fInput.files.length > 0) { return; }
    const opts = document.getElementById('category').options;
    var input = document.getElementById('spot-image');
    if (opts[0].selected && opts[1].selected && opts[2].selected) { input.src = defaultImages[6]; }
    else if (opts[0].selected && opts[1].selected) { input.src = defaultImages[3]; }
    else if (opts[0].selected && opts[2].selected) { input.src = defaultImages[4]; }
    else if (opts[1].selected && opts[2].selected) { input.src = defaultImages[5]; }
    else if (opts[1].selected) { input.src = defaultImages[1]; }
    else if (opts[0].selected) { input.src = defaultImages[0]; }
    else { input.src = defaultImages[2]; }
}

async function getAttributes() {
    const query = new Parse.Query('WheelSpotAttribute');
    try {
        attributes = await query.find();
        var input = document.getElementById('category');
        const categories = attributes.filter(a => a.get('Type') == 'Category');
        categories.forEach(c => {
            const o = document.createElement('option');
            o.text = c.get('Value');
            o.value = c.id;
            input.add(o)
        });

        [...input.options].forEach(function (element) {
            element.addEventListener("mousedown",
                function (e) {
                    e.preventDefault();
                    element.parentElement.focus();
                    this.selected = !this.selected;
                    updateDefaultImage();
                    return false;
                }, false);
        });

        input = document.getElementById('setting');
        const settings = attributes.filter(a => a.get('Type') == 'Setting');
        settings.forEach(c => {
            const o = document.createElement('option');
            o.text = c.get('Value');
            o.value = c.id;
            input.add(o)
        });

        [...input.options].forEach(function (element) {
            element.addEventListener("mousedown",
                function (e) {
                    e.preventDefault();
                    element.parentElement.focus();
                    this.selected = !this.selected;
                    return false;
                }, false);
        });

    } catch (error) {
        throw (error);
    }
}

/**
 * Spot Calls
 */
async function getSpots() {
    const query = new Parse.Query('WheelSpot');
    query.ascending('Name');
    try {
        currentDataSource = await query.find();
    } catch (error) {
        throw (error);
    }
}

const renderSpots = () => {
    const spots = document.getElementById('admin_data');
    spots.innerHTML = '';
    for (var i = 0; i < currentDataSource.length; i++) {
        const spot = currentDataSource[i];

        const row = document.createElement('div');
        const cellName = document.createElement('div');
        const cellCategory = document.createElement('div');
        const cellHasSnacks = document.createElement('div');
        const cellSetting = document.createElement('div');
        const cellParty = document.createElement('div');
        const cellAddy = document.createElement('div');
        const cellSite = document.createElement('div');
        const cellSaid = document.createElement('div');
        const cellSayer = document.createElement('div');
        const cellHasSnacksIcon = document.createElement('img');
        const cellPartyIcon = document.createElement('img');
        const cellSiteAnchor = document.createElement('a');

        row.classList.add('table-row');
        cellName.classList.add('cell-name');
        cellCategory.classList.add('cell-category');
        cellHasSnacks.classList.add('cell-large-party');
        cellSetting.classList.add('cell-setting');
        cellParty.classList.add('cell-large-party');
        cellAddy.classList.add('cell-address');
        cellSite.classList.add('cell-website');
        cellSaid.classList.add('cell-quote');
        cellSayer.classList.add('cell-said-by');

        spots.append(row);
        row.append(cellName, cellCategory, cellHasSnacks, cellSetting, cellParty, cellAddy, cellSite, cellSaid, cellSayer);
        cellParty.append(cellPartyIcon);
        cellHasSnacks.append(cellHasSnacksIcon);
        cellSite.append(cellSiteAnchor);

        cellName.innerHTML = spot.get('Name');
        var values = attributes.filter(a => spot.get('Category').includes(a.id));
        values.forEach(v => {
            const catTag = document.createElement('div');
            catTag.classList.add('tag');
            catTag.innerHTML = v.get('Value');
            if (v.get('Value') === 'Happy Hour') {
                catTag.classList.add('happy-hour');
            } else if (v.get('Value') === 'Coffee') {
                catTag.classList.add('coffee');
            }
            cellCategory.append(catTag);
        })

        let iconURL;
        if (spot.get('HasSnacks') == true) {
            iconURL = new URL('../svgs/check-wheel.svg', import.meta.url);
        } else {
            iconURL = new URL('../svgs/x-wheel.svg', import.meta.url);
        }
        cellHasSnacksIcon.src = iconURL;

        values = attributes.filter(a => spot.get('Setting').includes(a.id));
        values.forEach(v => {
            const setSpan = document.createElement('span');
            setSpan.innerHTML = v.get('Value');
            cellSetting.append(setSpan);
        })

        if (spot.get('LargeParties') == true) {
            iconURL = new URL('../svgs/check-wheel.svg', import.meta.url);
        } else {
            iconURL = new URL('../svgs/x-wheel.svg', import.meta.url);
        }

        cellPartyIcon.src = iconURL;
        if (spot.get('Address').indexOf(', Austin') > -1) {
            cellAddy.innerHTML = spot.get('Address').substring(0, spot.get('Address').indexOf(', Austin'));
        } else {
            cellAddy.innerHTML = spot.get('Address');
        }
        cellSiteAnchor.href = spot.get('WebsiteUrl');
        cellSiteAnchor.setAttribute("target", '_blank');
        cellSiteAnchor.innerHTML = spot.get('WebsiteUrl');
        if (spot.get('Quote')) {
            cellSaid.innerHTML = `"${spot.get('Quote').replace(new RegExp('"', 'g'), '')}"`;
        }
        if (spot.get('Quotee')) {
            cellSayer.innerHTML = spot.get('Quotee');
        }

        const clicker = document.createElement('div');
        clicker.classList.add('row')
        clicker.id = spot.id;
        clicker.addEventListener('click', editSpot);
        row.append(clicker);
    }
}


const editSpot = (e) => {
    isEditing = true;
    btnDel.classList.remove('hidden');
    currentDataEdit = currentDataSource.filter(p => p.id == e.target.id)[0];
    if (!currentDataEdit) { return; }

    const fInput = document.getElementById('input_file');
    document.getElementById('form-title').innerHTML = 'Edit spot';
    fInput.value = '';

    spotModal.classList.remove('hidden');
    adminTable.classList.add('hidden');

    var input = document.getElementById('name');
    input.value = currentDataEdit.get('Name');

    input = document.getElementById('category');
    [...input.options].forEach(function (element) {
        element.selected = currentDataEdit.get('Category').includes(element.value)
    });

    input = document.getElementById('setting');
    [...input.options].forEach(function (element) {
        element.selected = currentDataEdit.get('Setting').includes(element.value)
    });

    input = document.getElementById('large-group');
    input.selectedIndex = currentDataEdit.get('LargeParties') ? 0 : 1;

    input = document.getElementById('has-snacks');
    input.selectedIndex = currentDataEdit.get('HasSnacks') ? 0 : 1;

    var val = currentDataEdit.get('Quote');
    input = document.getElementById('quote');
    if (val) {
        input.value = currentDataEdit.get('Quote');
    }
    else {
        input.value = '';
    }

    var val = currentDataEdit.get('Quotee');
    input = document.getElementById('quotee');
    if (val) {
        input.value = currentDataEdit.get('Quotee');
    }
    else {
        input.value = '';
    }

    input = document.getElementById('address');
    input.value = currentDataEdit.get('Address');

    input = document.getElementById('map-link');
    input.value = currentDataEdit.get('MapUrl');

    input = document.getElementById('website');
    input.value = currentDataEdit.get('WebsiteUrl');

    val = currentDataEdit.get('Image');
    if (val) {
        input = document.getElementById('spot-image');
        input.src = val.url();
    }
    else {
        updateDefaultImage();
    }
}

const newSpot = () => {
    resetSpotUI();
    isEditing = false;
    btnDel.classList.add('hidden');
    document.getElementById('form-title').innerHTML = 'Add spot';
    spotModal.classList.remove('hidden');
    adminTable.classList.add('hidden');
}

const saveSpot = (e) => {
    e.stopPropagation();

    const fInput = document.getElementById('input_file');
    let parseFile;

    cats = [...document.getElementById('category').options].filter(o => o.selected);
    sets = [...document.getElementById('setting').options].filter(o => o.selected);

    if (document.getElementById('name').value.length < 1 ||
        cats.length < 1 ||
        sets.length < 1 ||
        document.getElementById('address').value.length < 1 ||
        document.getElementById('map-link').value.length < 1) {
        alert("🤬 Yo, all values are required for a spot. 🤬");
        return;
    }

    setUIState(false);
    if (fInput.files.length > 0) {
        const file = fInput.files[0];
        const name = fInput.files[0].name;
        parseFile = new Parse.File(name, file);
    }
    if (parseFile) {
        parseFile.save().then(() => {
            saveSpotCore(parseFile);
        }, function (error) {
            window.alert('Error while saving image', error);
        });
    }
    else {
        saveSpotCore();
    }

    spotModal.classList.add('hidden');
    adminTable.classList.remove('hidden');
}

const saveSpotCore = (i) => {
    const WheelSpot = Parse.Object.extend('WheelSpot');
    const wp = new WheelSpot();
    if (currentDataEdit) {
        wp.set('objectId', currentDataEdit.id);
    }
    wp.set('Name', document.getElementById('name').value);
    wp.set('Quote', document.getElementById('quote').value);
    wp.set('Quotee', document.getElementById('quotee').value);
    wp.set('Address', document.getElementById('address').value);
    wp.set('MapUrl', document.getElementById('map-link').value);
    wp.set('WebsiteUrl', document.getElementById('website').value);
    wp.set('HasSnacks', document.getElementById('has-snacks').selectedIndex == 0);
    wp.set('LargeParties', document.getElementById('large-group').selectedIndex == 0);
    var vals = cats.map(c => c.value);
    wp.set('Category', vals);
    var vals = sets.map(c => c.value);
    wp.set('Setting', vals);

    if (i) {
        wp.set('Image', i);
    }
    wp.save().then((r) => {
        setUIState(true);
        if (isEditing) {
            isEditing = false;
        }
        else {
            currentDataSource.push(r);
        }
        resetSpotUI();
        renderSpots();
    }, (error) => {
        setUIState(true);
        alert('Failed saving object: ' + error);
    });
}

const cancelSpot = (e) => {
    if (e) { e.stopPropagation(); }
    isEditing = false;
    spotModal.classList.add('hidden');
    adminTable.classList.remove('hidden');
}

const resetSpotUI = () => {
    currentDataEdit = null;

    var input = document.getElementById('name');
    input.value = '';

    input = document.getElementById('category');
    for (var i = 0; i < input.options.length; i++) {
        input.options[i].selected = i == 0;
    }

    input = document.getElementById('setting');
    for (var i = 0; i < input.options.length; i++) {
        input.options[i].selected = i == 0;
    }

    input = document.getElementById('large-group');
    input.selectedIndex = 1;

    input = document.getElementById('has-snacks');
    input.selectedIndex = 1;

    input = document.getElementById('quote');
    input.value = '';

    input = document.getElementById('address');
    input.value = '';

    input = document.getElementById('map-link');
    input.value = '';

    input = document.getElementById('website');
    input.value = '';


    input = document.getElementById('spot-image');
    input.src = defaultImages[0];
}

function handleParseError(msg, err) {
    switch (err.code) {
        case Parse.Error.INVALID_SESSION_TOKEN:
            Parse.User.logOut();
            window.location = `${window.location.origin}/${(window.location.pathname.includes("staging") ? "staging/" : "")}login.html?redirect=${window.location.pathname}`;
            break;
        default:
            console.log(`${msg} : ${err.code} - ${err.message}`);
    }
}
